export var Groups = {
    Appearance: "Appearance",
    Arena: "Arena",
    Brand: "Brand",
    Championship: "Championship",
    Contract: "Contract",
    Draft: "Draft",
    Faction: "Faction",
    Feud: "Feud",
    Injury: "Injury",
    Mail: "Mail",
    Notification: "Notification",
    Production: "Production",
    Reign: "Reign",
    Rumble: "Rumble",
    Segment: "Segment",
    Show: "Show",
    Tournament: "Tournament",
    Wrestler: "Wrestler"
};
